import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, shareReplay, startWith, Subject, switchMap } from "rxjs";
import {
  ApiReservation,
  CreateReservationDto,
  UpdateReservationDto,
} from "../models";

@Injectable({ providedIn: "root" })
export class ReservationService {
  private readonly base = window.location.port === "4200" ? "/api" : "/api"; // dev et prod via /api
  private opts = { withCredentials: true };
  private refresh$ = new Subject<void>();

  // Flux public si tu en as besoin ailleurs (typé sur la forme API)
  readonly reservations$ = this.refresh$.pipe(
    startWith(void 0),
    switchMap(() =>
      this.http.get<ApiReservation[]>(`${this.base}/reservation`)
    ),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(private http: HttpClient) {}

  getReservations(
    fromISO: string,
    toISO: string
  ): Observable<ApiReservation[]> {
    const params = new HttpParams().set("from", fromISO).set("to", toISO);
    return this.http.get<ApiReservation[]>(`${this.base}/reservation`, {
      params,
      withCredentials: true,
    });
  }

  createReservation(dto: CreateReservationDto): Observable<ApiReservation> {
    // dto accepte aircraftId ET/OU instructorId à null
    return this.http.post<ApiReservation>(
      `${this.base}/reservation`,
      dto,
      this.opts
    );
  }

  updateReservation(
    id: string,
    dto: UpdateReservationDto
  ): Observable<ApiReservation> {
    return this.http.put<ApiReservation>(
      `${this.base}/reservation/${id}`,
      dto,
      this.opts
    );
  }

  deleteReservation(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/reservation/${id}`, this.opts);
  }
}
